(function($) {

	'use strict';

	function init() {
        initListeners();
	};

    function initListeners() {

        $('.pageTitle__links__audio').on('click keypress', function() {
            let audio = $(this).find('audio')[0];

            audio.paused ? audio.play() : audio.pause();
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
